import _ from 'lodash';

class CartaPorteMercanciasCalculator {
  data = {}

  constructor(data) {
    this.data = data;
  }

  static make(data) {
    return new CartaPorteMercanciasCalculator(data);
  }

  get() {
    const PesoBrutoTotal = this.getPesoBrutoTotal();
    const NumTotalMercancias = this.getNumTotalMercancias();

    return {
      PesoBrutoTotal,
      NumTotalMercancias,
    }
  }

  getPesoBrutoTotal() {
    return _.sumBy(this._getMercancias(), (item) => {
      return parseFloat(item.PesoEnKg);
    });
  }

  getNumTotalMercancias() {
    return this.data.length;
  }

  getUnidadPeso() {
    return _.map(this._getMercancias(), (item) => {
      return item.ClaveUnidad;
    });
  }

  _getMercancias(haystack = [], flag = 0) {
    if (flag === 1) {
      return this.data.filter((item) => {
        return haystack.indexOf(item.TipoPercepcion) !== -1;
      });
    }

    return this.data.filter((item) => {
      return haystack.indexOf(item.BienesTransp) === -1;
    });
  }

}

export default CartaPorteMercanciasCalculator;